import { createRouter, createWebHistory } from 'vue-router';
import { getters as auth, login } from '../services/auth.service';

export function createHiveRouter() {
    return createRouter({
        history: createWebHistory('/'),
        routes: [
            {
                path: '/',
                redirect: { name: 'dashboard' },
            },
        ],
    });
}

export function setupHiveRouter(router) {
    router.beforeEach((to) => {
        if (to.meta?.public) {return true;}

        if (!auth.isAuthenticated) {
            login();

            return false;
        }

        // Role-guarded routes (e.g. Tenant is admin-only): send others home
        // rather than showing a 403 page.
        if (to.meta?.roles && !to.meta.roles.some((role) => auth.hasRole(role))) {
            return { name: 'dashboard' };
        }

        return true;
    });

    router.afterEach((to) => {
        document.title = to.meta?.title ? `${to.meta.title} — Hive` : 'Hive';
    });
}
